import { createSlice } from "@reduxjs/toolkit";
import cards from "./cards";

function shuffle(arr, count) {
  // Mix all cards
  let i = arr.length;
  while (--i > 0) {
    let randIndex = Math.floor(Math.random() * (i + 1));
    [arr[randIndex], arr[i]] = [arr[i], arr[randIndex]];
  }
  // Take needed count of cards and mix again
  arr = arr.slice(0, count);
  arr = arr.flatMap((i) => [i, i]);
  i = arr.length;
  while (--i > 0) {
    let randIndex = Math.floor(Math.random() * (i + 1));
    [arr[randIndex], arr[i]] = [arr[i], arr[randIndex]];
  }
  let deck = [];
  arr.map((item, i) => deck.push({ name: item, show: false, id: i }));
  return deck;
}

const sortWinners = (arr) => {
  arr = arr.sort((a, b) => a.moves - b.moves).slice(0, 10);
  return arr;
};

const cardsNeeded = [2, 8, 18, 32];

const getWinners = () => {
  const saved = localStorage.getItem("memory-game-winners");
  const initial = JSON.parse(saved);
  const defaultValue = [];
  console.log(initial);
  return initial || defaultValue;
};

const getDatetime = () => {
  let d = new Date();
  return `${("0" + d.getDate()).slice(-2)}.${("0" + (d.getMonth() + 1)).slice(
    -2
  )}.${("0" + d.getYear()).slice(-2)} ${("0" + d.getHours()).slice(-2)}:${(
    "0" + d.getMinutes()
  ).slice(-2)}`;
};

const initialState = {
  cards: shuffle(cards, 2),
  moves: 0,
  level: 0,
  selectedCards: [],
  cols: 2,
  won: false,
  winners: getWinners(),
  showModal: false,
};

const boardSlice = createSlice({
  name: "board",
  initialState,
  reducers: {
    resetBoard: (state) => {
      state.cards = shuffle(cards, 2);
      state.level = 0;
      state.selectedCards = [];
      state.cols = 2;
      state.won = false;
      state.moves = 0;
    },
    turnCard: (state, { payload }) => {
      let id = payload;
      if (state.selectedCards.includes(id) || state.selectedCards.length === 2)
        return;
      state.selectedCards.push(id);
      state.cards[id].show = true;
      state.moves += 1;
    },
    checkCards: (state) => {
      if (state.selectedCards.length === 2) {
        const [id0, id1] = state.selectedCards;
        if (state.cards[id0].name !== state.cards[id1].name) {
          state.cards[id0].show = false;
          state.cards[id1].show = false;
        }
        state.selectedCards = [];
      }
      const cardsToGo = state.cards.reduce((hidden, item) => {
        if (item.show) {
          return hidden;
        } else {
          return hidden + 1;
        }
      }, 0);
      if (cardsToGo === 0) {
        if (state.level < 3) {
          state.level += 1;
          state.moves = 0;
          state.cards = shuffle(cards, cardsNeeded[state.level]);
          state.cols = (state.level + 1) * 2;
        } else {
          state.won = true;
          let mostMoves = 0;
          if (state.winners.lenght > 0) {
            mostMoves = state.winners[state.winners.lenght - 1].moves;
          }
          console.log(state.winners.lenght - 1, mostMoves);
          if (mostMoves === 0 || state.moves < mostMoves) {
            state.showModal = true;
          }
        }
      }
    },
    addWinner: (state, { payload }) => {
      state.winners.push({
        name: payload,
        moves: state.moves,
        datetime: getDatetime(),
      });
      state.winners = sortWinners(state.winners);
      state.showModal = false;
      localStorage.setItem(
        "memory-game-winners",
        JSON.stringify(state.winners)
      );
    },
    hideModal: (state) => {
      state.showModal = false;
    },
  },
});

export const { resetBoard, turnCard, checkCards, addWinner, hideModal } =
  boardSlice.actions;

export default boardSlice.reducer;
